/* eslint-disable @typescript-eslint/no-empty-function */
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseFormFieldComponent } from '../base-form-field.component';

@Component({
  selector: 'ellf-numeric-field',
  template: `
    <ellf-form-field-wrapper
      [label]="label"
      [shouldShowError]="shouldShowError"
      [errors]="errors"
      [tooltip]="tooltip"
    >
      <ellf-numeric-input
        [hasError]="shouldShowError"
        [formControl]="formControl"
        (blur)="onBlur()"
        [digits]="digits"
        [min]="min"
        [max]="max"
        [prefix]="isCurrency ? '€ ' : ''"
        [digitsOptional]="nullable ? true : isCurrency ? false : true"
        [nullable]="nullable"
        [showGroupSeparator]="showGroupSeparator"
        [readOnly]="readOnly"
      >
      </ellf-numeric-input>
    </ellf-form-field-wrapper>
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NumericFieldComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NumericFieldComponent extends BaseFormFieldComponent {
  @Input()
  digits: number | '*' = 2;

  @Input()
  min?: number;

  @Input()
  max?: number;

  @Input()
  isCurrency = false;

  @Input()
  nullable = false;

  _value: any = undefined;
  @Input()
  public set value(v: any) {
    this._value = v;
    this.formControl.setValue(v, { emitEvent: false });
  }

  @Input()
  showGroupSeparator = true;

  @Output()
  changed = new EventEmitter<any>();

  @Output()
  // eslint-disable-next-line @angular-eslint/no-output-native
  blur = new EventEmitter();

  onBlur() {
    this.blur.emit();
  }
  onChanged(v: any) {
    super.onChanged(v);
    this.changed.emit(v);
  }
}
